import Vue from 'vue'
import Router from 'vue-router'

const Frame = () => import('@/components/frames/frame')
const Index = () => import('@/pages/teacher/index')
const Teacher = () => import('@/pages/teacher/teacher')
const Qa = () => import('@/pages/teacher/qa')

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'frame',
    component: Frame,
    redirect: '/index',
    children: [{
      path: '/index',
      name: 'index',
      meta: {title: '首页'},
      component: Index
    },
    {
      path: '/teacher',
      name: 'teacher',
      meta: {title: '师资认证查询', bgcolor: '#f1f1f1'},
      component: Teacher
    },
    {
      path: '/qa',
      name: 'qa',
      meta: {title: '常见问题'},
      component: Qa
    }]
  }]
})

export default router



// WEBPACK FOOTER //
// ./src/router/routerMap.js